import React from "react";
import {
  DrawerSelection,
  Plan2PlateDrawer,
  Plan2PlateDrawerHeader,
} from "./Plan2PlateDrawer";
import { ImageScannerHiddenInput } from "./ImageScannerHiddenInput";

export type AiSourceSelectionDrawerProps = {
  open: boolean;
  onClose: () => void;
  onSelectDescription: () => void;
  onSelectUrl: () => void;
  onSelectImage: (file: File) => void;
  /** Zeigt die Option "Aus Bezeichnung" nur, wenn eine Bezeichnung vorhanden ist. */
  showDescriptionOption: boolean;
};

/**
 * Fragt, woher die Nährwerte eines Lebensmittels/Produkts abgeleitet werden
 * sollen: aus der Bezeichnung (KI-Wissen), aus einer Webseite (URL) oder aus
 * einem Foto der Nährwertangaben. Wird von Food- und PurchaseEditor geteilt.
 */
export const AiSourceSelectionDrawer = ({
  open,
  onClose,
  onSelectDescription,
  onSelectUrl,
  onSelectImage,
  showDescriptionOption,
}: AiSourceSelectionDrawerProps) => {
  const { trigger: triggerCamera, input: cameraInput } =
    ImageScannerHiddenInput({
      onFileScanned: (file) => {
        onSelectImage(file);
        onClose();
      },
    });

  return (
    <>
      {cameraInput}
      <Plan2PlateDrawer
        open={open}
        onClose={onClose}
        header={<Plan2PlateDrawerHeader heading="Nährwerte ableiten" />}
        body={
          <>
            {showDescriptionOption && (
              <DrawerSelection
                dataCy="ai-source-description"
                onClick={onSelectDescription}
                icon="magicWandSparkles"
                heading="Aus Bezeichnung"
                description="Nährwerte aus dem Namen schätzen"
              />
            )}
            <DrawerSelection
              dataCy="ai-source-url"
              onClick={onSelectUrl}
              icon="chain"
              heading="Aus URL"
              description="Nährwerte von einer Webseite übernehmen"
            />
            <DrawerSelection
              dataCy="ai-source-image"
              onClick={triggerCamera}
              icon="clipboardImage"
              heading="Foto"
              description="Nährwertangaben von einem Foto übernehmen"
            />
          </>
        }
      />
    </>
  );
};
